import React from "react";
import { FaqQ, FaqA } from "assets/svg";
import { scroolElement } from "utils/common";

const CardQA = ({ qa, reference }) => {

  const renderItems = (items, reference_qa) => {
    return (
      <>
        {items
          .filter(item => item.reference_qa === reference_qa)
          .map((item,index) => 
          (
            <div key={item.id} className={"padding-left-right-relate-item mb-1 cursor-pointer " + (index === 0 ? 'mt-3' : '')} onClick={() => scroolElement("#qaid" + item.id.toString(), 100)}>
              {
                index === 0 ?
                <div className="row">
                <div className="col-2 no-padding-no-margin width-question">
                関連項目：
                </div>
                <div className="col no-padding-no-margin">
                {item.question}
                </div>
                </div>
                :
                <div className="row">
                <div className="col-2 no-padding-no-margin width-question">
                </div>
                <div className="col no-padding-no-margin">
                {item.question}
                </div>
                </div>
              // `${item.question}` :
              // <span className="mx-5">{item.question}</span>
              } 
            </div>
          )
          )
          }
      </>
    );
  }

  return (
    <div id={`qaid${qa.id}`} className="bg-white border-radius-5 px-2 px-md-3 my-1 py-2">
      <div className="fs-16 fs-sm-14 text-question fw-600 d-flex me-2 mb-2">
        <span className="align-self-start d-inline-block me-3 me-md-4 qa">
          <FaqQ />
        </span>
        <div>{qa.question}</div>
      </div>
      <div className="html-design-table fw-400 d-flex align-items-center">
        <span className="align-self-start d-inline-block me-3 me-md-4 qa">
          <FaqA />
        </span>
        <span dangerouslySetInnerHTML={{ __html: qa.answer }}></span>
      </div>
      {renderItems(reference, qa.id)}
    </div>
  );
};

export default CardQA;
